import React, { useCallback, useState } from "react";
import AddIcon from "@mui/icons-material/Add";

import { MachineEditorDialog } from "./MachineEditorDialog";

/**
 * The "+" in the slack view search bar, next to the QR scanner and the inspector flag.
 * Opens the create-machine popover. Styling lives in index.css (.add-machine-button).
 */
export const AddMachineButton: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  return (
    <>
      <div
        className="pointer add-machine-button"
        role="button"
        aria-label="Add a machine"
        title="Add a machine"
        onClick={open}
      >
        <AddIcon />
      </div>

      <MachineEditorDialog open={isOpen} mode="create" onClose={close} />
    </>
  );
};
